export function SalesforceIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-label='Salesforce'
      role='img'
    >
      <path d='M14.5 5.5a4 4 0 0 1 3.4 1.9 3.3 3.3 0 0 1 .6-.06 3.3 3.3 0 0 1 1.2 6.36A2.9 2.9 0 0 1 18 19H8.2A3.7 3.7 0 0 1 7 11.75a4.6 4.6 0 0 1 4.5-3.75 4.6 4.6 0 0 1 1 .11A4 4 0 0 1 14.5 5.5z' />
    </svg>
  );
}
